@if (!((appService.loadingTOL$ | async) || (appService.loading$ | async))) {
  <div class="skip-link-wrapper">
    <a matButton="elevated" [href]="appService.currentUrl+'#maincontent'"
    [attr.inert]="(appService.pageLoading$ | async) || (appService.loading$ | async) ? '' : null">Skip to Main Content</a>
  </div>
}

<!-- The hasBackdrop property of mat-sidenav-container indirectly produces invisible divs that can be focused by tab navigation (which is undesirable).
Additionally, we don't actually want a backdrop for any of our sidenavs when at fullscreen anyway, so we dynanically bind them to address these issues.
Since the intended focus trapping is not working as expected (primarily when position is set to 'end' on the sidenav), we are using our own directive. -->

<!-- container for the navigation rail (profile pages, desktop only) -->
<mat-sidenav-container class="rail-shell-container"
  [attr.inert]="(appService.pageLoading$ | async) || (appService.loading$ | async) ? '' : null">
  @if (railShowing) {
    <mat-sidenav class="mat-sidenav--rail"
      fixedInViewport role="navigation" mode="side" disableClose
      [fixedTopGap]="64" [opened]="true">
      <app-rail-navigation></app-rail-navigation>
    </mat-sidenav>
  }
  <mat-sidenav-content class="rail-shell-content">
    <!-- container for help menu -->
    <mat-sidenav-container class="app-container gcr-drawer-scrim"
      [attr.aria-busy]="(appService.loading$ | async) ? 'true' : 'false'"
      [hasBackdrop]="help.opened">
        <!-- content beneath cart/mobile menu-->
      <mat-sidenav-content>
        <app-header
          [siteTitle]="siteMetadataService.customization.title + ' ' + siteMetadataService.customization.subtitle"
          (toggleMobileMenu)="toggleMobileMenu()"
          (toggleHelp)="toggleHelp()"
          (toggleCart)="toggleCart()"
          (toggleAccountMenu)="toggleAccountMenu()"
          [mobileMenuOpened]="mobilemenu.opened"
          [helpOpened]="help.opened"
          [cartItemCount]="cartItemCount"
          [cartOpened]="cart.opened"
          [accountMenuOpened]="accountmenu.opened">
        </app-header>

        <!-- container for the account menu (mobile-only, right) -->
        <mat-sidenav-container class="account-menu-container gcr-drawer-scrim"
          [hasBackdrop]="appService.isMobile && accountmenu.opened">
          <mat-sidenav-content>

            <!-- container for cart/mobile menu -->
            <mat-sidenav-container class="inner-container gcr-drawer-scrim" [hasBackdrop]="cart.opened || (appService.isMobile && mobilemenu.opened)">
            <!-- mobile menu, left-->
            <mat-sidenav class="mat-sidenav--mobile-menu" #mobilemenu
              [appRestrictFocus]="appService.isMobile && mobilemenu.opened"
              fixedInViewport
              id="mobile-menu-sidebar"
              aria-label="Online Services"
              role="navigation"
              mode="over"
              [opened]="false"
              (openedStart)="menuOpening()">
              @if (!((appService.loadingTOL$ | async) || (appService.loading$ | async))) {
                <app-mobile-menu></app-mobile-menu>
              }
            </mat-sidenav>

            <!-- app content, beneath cart/mobile menu -->
            <mat-sidenav-content class="main-layout">
              @if (notificationBannerService.enabled) {
                <teller-online-notification-banner
                  [ngClass]="notificationBannerService.banners[0]?.bannerClass"
                  [message]="notificationBannerService.banners[0]?.message"
                  [dismissAction]="notificationBannerService.banners[0]?.dismissAction"
                  [resolveAction]="notificationBannerService.banners[0]?.resolveAction"
                  [icon]="notificationBannerService.banners[0]?.icon"
                  [iconColor]="notificationBannerService.banners[0]?.iconColor"
                  [tag]="notificationBannerService.banners[0]?.tag">
                </teller-online-notification-banner>
              }

              <!-- tabindex="-1" makes this a programmatic focus target: the skip link lands
                   here, and RestrictFocusDirective hands focus back here when a drawer closes on
                   a route that renders no #main-content-focus of its own. -->
              <main id="maincontent" tabindex="-1" [ngClass]="{
                'debug': appService.debug,
                'main-layout--verification': userMustVerifyEmail,
                'main-layout--tol-loading': (appService.loadingTOL$ | async)
              }">
                @if ((appService.loading$ | async) === false) {
                  <router-outlet>
                  </router-outlet>
                }
                <article class="skeleton-content" aria-hidden="true">
                  <header
                    [class.banner]="!isRailFillPage"
                    [class.profile-page-header]="isRailFillPage">
                    <div class="layout-grid">
                      <div class="skeleton-title">&nbsp;</div>
                    </div>
                  </header>
                </article>
              </main>

              <app-footer></app-footer>
            </mat-sidenav-content><!-- end content beneath cart/mobile menu -->

            <!-- cart, right-->
            <mat-sidenav #cart
              id="cart-sidebar"
              class="mat-sidenav--cart"
              [appRestrictFocus]="cart.opened"
              fixedInViewport
              position="end"
              fixedTopGap="0"
              role="region"
              mode="over"
              [opened]="false"
              (openedStart)="cartOpening()"
              (closed)="cartClosed()">
              <app-cart
                [ngClass]="{
                  'cart--empty': cartItemCount < 1
                }"
                (toggleCart)="toggleCart()">
              </app-cart>
            </mat-sidenav>
            </mat-sidenav-container><!-- end container for app/mobile menu -->

          </mat-sidenav-content>

          <!-- account menu, right -->
          <mat-sidenav #accountmenu
            id="account-sidebar"
            class="mat-sidenav--account-menu"
            [appRestrictFocus]="appService.isMobile && accountmenu.opened"
            fixedInViewport
            position="end"
            fixedTopGap="0"
            role="region"
            mode="over"
            [opened]="false"
            (openedStart)="accountMenuOpening()">
            <app-account-menu></app-account-menu>
          </mat-sidenav>
        </mat-sidenav-container><!-- end account menu container -->
      </mat-sidenav-content><!-- end content beneath help menu -->

      <!-- help menu, right — always a modal side sheet that overlays the fixed header with a
      backdrop and focus trap, same as the cart. -->
      <mat-sidenav #help
        id="help-sidebar"
        [appRestrictFocus]="help.opened"
        class="mat-sidenav--help"
        fixedInViewport
        position="end"
        fixedTopGap="0"
        role="region"
        mode="over"
        (openedStart)="helpOpening()"
        (closed)="helpClosed()">
        <teller-online-help-sidebar (toggleHelp)="toggleHelp()"></teller-online-help-sidebar>
      </mat-sidenav>
    </mat-sidenav-container><!-- end app container -->
      </mat-sidenav-content><!-- end rail-shell content -->
    </mat-sidenav-container><!-- end rail-shell container -->
<teller-online-load-panel></teller-online-load-panel>
